import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Lock, Mail } from "lucide-react";
import { toast } from "sonner";

const LOGO = "https://customer-assets.emergentagent.com/job_media-insights-26/artifacts/jyhdvnlr_logo-png-cuadrado.png";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.email) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Bienvenido al panel Core");
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F8FA] flex items-center justify-center px-5">
      <div className="w-full max-w-md bg-white border border-[#E3DDE8] p-10 shadow-[0_20px_60px_rgba(46,38,56,0.08)]">
        <div className="flex items-center gap-3 mb-8">
          <img src={LOGO} alt="Core" className="h-10 w-10 object-contain"/>
          <div>
            <div className="font-display font-extrabold text-[#2E2638] text-lg leading-none">CORE</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#8B1538] font-bold">Panel admin</div>
          </div>
        </div>
        <h1 className="font-display text-3xl font-bold text-[#2E2638] mb-2">Accede a tus leads</h1>
        <p className="text-sm text-[#5C5366] mb-8">Solo para asesores autorizados de Core Colchón.</p>

        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-6">
          <div>
            <label className="text-xs uppercase tracking-wider text-[#5C5366] flex items-center gap-2 mb-1">
              <Mail size={14}/> Email
            </label>
            <input
              data-testid="admin-login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b-2 border-[#E3DDE8] focus:border-[#8B1538] py-3 outline-none text-[#2E2638]"
              placeholder="admin@corecolchon.com"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-[#5C5366] flex items-center gap-2 mb-1">
              <Lock size={14}/> Contraseña
            </label>
            <input
              data-testid="admin-login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b-2 border-[#E3DDE8] focus:border-[#8B1538] py-3 outline-none text-[#2E2638]"
              placeholder="••••••••"
            />
          </div>
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full px-6 py-4 bg-[#8B1538] hover:bg-[#6A0F2A] disabled:opacity-60 text-white font-bold uppercase tracking-wider text-sm transition-all shadow-[0_4px_14px_rgba(139,21,56,0.35)] flex items-center justify-center gap-2"
          >
            {loading ? <Loader2 size={18} className="animate-spin"/> : null}
            Entrar
          </button>
        </form>

        <a href="/" className="mt-8 block text-center text-xs text-[#5C5366] hover:text-[#8B1538]">← Volver a la web</a>
      </div>
    </div>
  );
}
